import { render } from "./AutomaticStakeForm.vue?vue&type=template&id=26ff15e2&scoped=true"
import script from "./AutomaticStakeForm.vue?vue&type=script&lang=js"
export * from "./AutomaticStakeForm.vue?vue&type=script&lang=js"

import "./AutomaticStakeForm.vue?vue&type=style&index=0&id=26ff15e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ff15e2"]])

export default __exports__